const formatDate = (time: Date) => {
  // Given timestamp
  const timestamp = time.toString();

  // Create a Date object from the timestamp
  const date = new Date(timestamp);

  // Extract date components
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1; // Months are zero-indexed
  const year = date.getUTCFullYear();

  // Extract time components
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  // Format the date components with leading zeros if necessary
  const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;

  // Format the time components with leading zeros if necessary
  const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
    seconds < 10 ? '0' : ''
  }${seconds}`;

  // Combine date and time components
  const result = `${formattedDate} ${formattedTime}`;

  return result;
};

const formatDateStr = (date: Date, show?: boolean) => {
  try {
    const padZero = (num: number) => {
      return num < 10 ? '0' + num : num;
    };

    const formattedDate = new Date(date).toLocaleString('en-US', { hour12: false });
    const [datePart, timePart] = formattedDate.split(', ');
    const [month, day, year] = datePart.split('/');
    const [hour, minute, second] = timePart.split(':');

    const paddedDay = padZero(parseInt(day));
    const paddedMonth = padZero(parseInt(month));
    const paddedHour = padZero(parseInt(hour));
    const paddedMinute = padZero(parseInt(minute));
    const paddedSecond = padZero(parseInt(second));

    const formattedString = `${paddedDay}-${paddedMonth}-${year} ${paddedHour}:${paddedMinute}:${paddedSecond}`;
    const formattedStringNoTime = `${paddedDay}-${paddedMonth}-${year}`;
    if (show) {
      return formattedString;
    } else {
      return formattedStringNoTime;
    }
  } catch (e) {
    return 'ERROR';
  }
};

export const formatDateFilter = (date: string, withTime?: false) => {
  try {
    const padZero = (num: number) => {
      return num < 10 ? '0' + num : num;
    };

    const formattedDate = new Date(date).toLocaleString('en-US');
    const [datePart, timePart] = formattedDate.split(', ');
    const [month, day, year] = datePart.split('/');
    const [hour, minute, second] = timePart.split(':');

    const paddedDay = padZero(parseInt(day));
    const paddedMonth = padZero(parseInt(month));
    const paddedHour = padZero(parseInt(hour));
    const paddedMinute = padZero(parseInt(minute));
    const paddedSecond = padZero(parseInt(second));

    const formattedStringDate = `${year}-${paddedMonth}-${paddedDay}`;
    const formattedStringTime = `${paddedHour}:${paddedMinute}:${paddedSecond}`;
    if (withTime) return formattedStringDate + formattedStringTime;

    return formattedStringDate;
  } catch (e) {
    return 'ERROR';
  }
};

const calculateTimes = (date1: Date, date2: Date) => {
  try {
    let timeDifference;
    try {
      timeDifference = date2.getTime() - date1?.getTime();
    } catch (x) {
      timeDifference = 0;
    }

    // Calculate days, hours, and minutes
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    timeDifference -= days * (1000 * 60 * 60 * 24);

    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    timeDifference -= hours * (1000 * 60 * 60);

    const minutes = Math.floor(timeDifference / (1000 * 60));

    // Construct the result string
    let result = '';
    if (days > 0) {
      result += `${days} ວັນ `;
    }
    if (hours > 0) {
      result += `${hours} ຊົ່ວໂມງ `;
    }
    if (minutes > 0) {
      result += `${minutes} ນາທີ`;
    }
    if (result === '') {
      result = '0';
    }

    return result.trim();
  } catch (e) {
    console.log(e);

    return 'ERROR';
  }
};

const calculateTimesFromNow = (date: Date) => {
  try {
    let difference = date.getTime() - Date.now();

    // Calculate days, hours, and minutes
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    let formattedDifference = '';

    if (difference <= 0) {
      return 'ກາຍກຳນົດແລ້ວ';
    } else {
      if (days > 0) {
        formattedDifference += `${days} ວັນ`;
      } else if (hours > 0) {
        formattedDifference += ` ${hours} ຊົ່ວໂມງ`;
      } else if (minutes > 0) {
        formattedDifference += ` ${minutes} ນາທີ`;
      } else if (seconds > 0) {
        formattedDifference += ` ${seconds} ວິນາທີ`;
      }
      return formattedDifference;
    }
  } catch (e) {
    return 'ERROR';
  }
};

export const formatDateLocalUse = (date: string, type?: string) => {
  try {
    const padZero = (num: number) => {
      return num < 10 ? '0' + num : num;
    };

    const formattedDate = new Date(date).toLocaleString('en-US');
    const [datePart, timePart] = formattedDate.split(', ');
    const [month, day, year] = datePart.split('/');
    const [hour, minute, second] = timePart.split(':');

    const paddedDay = padZero(parseInt(day));
    const paddedMonth = padZero(parseInt(month));
    const paddedHour = padZero(parseInt(hour));
    const paddedMinute = padZero(parseInt(minute));
    const paddedSecond = padZero(parseInt(second));

    const formattedStringDate = `${paddedDay}-${paddedMonth}-${year}`;
    const formattedStringTime = `${paddedHour}:${paddedMinute}:${paddedSecond}`;
    if (type === 'time') {
      return formattedStringTime;
    } else {
      return formattedStringDate;
    }
  } catch (e) {
    return 'ERROR';
  }
};

export const formatDateToISO = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '';
  const dateParts = dateStr.match(/(\d{2})-(\d{2})-(\d{4})/);
  const dateParts2 = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (dateParts) {
    const [, day, month, year] = dateParts;
    const dateObj = new Date(`${year}-${month}-${day}T00:00:00Z`);
    if (isNaN(dateObj.getTime())) return '';
    return dateObj.toISOString();
  } else if (dateParts2) {
    const [, year, month, day] = dateParts2;
    const dateObj = new Date(`${year}-${month}-${day}T00:00:00Z`);
    if (isNaN(dateObj.getTime())) return '';
    return dateObj.toISOString();
  }
  return '';
};

export { formatDate, formatDateStr, calculateTimes, calculateTimesFromNow };
